import React from "react";
import { RecentVideosList } from "@modules/study/vlog";
import { LayoutMain } from "@unisearch/theme/layout";
import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";
const VlogPlaylist = dynamic(
  () => import("@modules/study/vlog/components/playlist"),
  {
    ssr: false,
  }
);

const RecentVideos = ({ recentVideo }) => {
  return (
    <LayoutMain
      footer_with_evaluation
      title={"Most Recent Videos"}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/vlog/recent`}
    >
      <RecentVideosList recentVideo={recentVideo} />
      <VlogPlaylist />
    </LayoutMain>
  );
};

export default RecentVideos;

export async function getServerSideProps({ query }) {
  let props = {
    recentVideo: "",
  };

  let page_limit = 20;
  let current_page = 1;

  const { limit, page } = query;

  if (limit && page) {
    page_limit = limit;
    current_page = page;
  } else {
    page_limit = 20;
    current_page = 1;
  }

  try {
    await API.get(
      `/public/vlog/recent?limit=${page_limit}&page=${current_page}`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.recentVideo = resp.data;
      } else {
        props.recentVideo = "";
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
